import { apiLaravelClient } from '../utils/apiLaravelClient';
import { apiClientNode } from '../utils/appDataClientNode';


const secondaryBaseUrl = "/api/v0.1"

export function getUserDetails() {
	return apiLaravelClient.post(`${secondaryBaseUrl}/user/details`);
}

export function getCurrentUserConfirmation(data) {
	return apiLaravelClient.post(`${secondaryBaseUrl}/videoroom/check/currentuser`, data);
}

export function getUserRole() {
	return apiLaravelClient.get(`${secondaryBaseUrl}/staffExchange/permissions`);
}


export function getUserContactList() {
	return apiLaravelClient.get(`${secondaryBaseUrl}/user/contacts/0?page=0&pageSize=20&sortBy=firstName&sortOrder=ASC&lastUpdate=0`);
}

export function getRegisteredUserContactList() {
	return apiLaravelClient.get(`${secondaryBaseUrl}/user/contacts/0?page=0&pageSize=20&sortBy=firstName&sortOrder=ASC&lastUpdate=0&contactType=onlyRegistered`);
}

export function getUserList(data) {
	return apiClientNode.post(`${secondaryBaseUrl}/video-room/search-users`, data);
}

export function getRecentUserList() {
	return apiClientNode.get(`${secondaryBaseUrl}/video-room/recent/joined`);
}

